import { AxiosError } from 'axios';

export const isApiError = (error: unknown): error is AxiosError => error instanceof AxiosError;
